import HTTP from '../../../../api/AxiosConfig';

export const getOrdersPage = (pageRequest) =>
    HTTP.post('/orders/page', pageRequest);

export const upsertOrder = (order) =>
    HTTP.post('/orders/upsert', order);

export const loadOrder = (orderId) =>
    HTTP.get('/orders?orderId=' + orderId);

export const deleteOrder = (orderId) =>
    HTTP.delete('/orders?orderId=' + orderId);

export const completeOrder = (request) =>
    HTTP.post('/orders/complete', request);